import { Skeleton } from "@/components/ui/skeleton";

const SKELETON_CARD_COUNT = 3;
const SKELETON_CARD_KEYS = Array.from(
  { length: SKELETON_CARD_COUNT },
  (_, index) => `skeleton-card-${index}`,
);

/** Placeholder cards that mirror the real card's rhythm while jobs load. */
export function RecommendedJobsSkeleton() {
  return (
    <div role="status" aria-busy="true" className="mx-auto max-w-xl space-y-4">
      <span className="sr-only">Finding your job matches...</span>
      {SKELETON_CARD_KEYS.map((key) => (
        <div
          key={key}
          className="space-y-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6"
        >
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-6 w-2/5" />
          <div className="flex gap-2">
            <Skeleton className="h-6 w-20" />
            <Skeleton className="h-6 w-16" />
          </div>
          <div className="space-y-2.5">
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-4 w-3/5" />
          </div>
          <div className="flex gap-3 border-t border-slate-200 pt-4">
            <Skeleton className="h-12 flex-1" />
            <Skeleton className="h-12 flex-1" />
          </div>
        </div>
      ))}
    </div>
  );
}
